export enum Method2fa {
    Email = 'EMAIL',
    Totp = 'TOTP',
    Sms = 'SMS',
}
